// Chime sintetizado con Web Audio API — sin archivos .mp3, igual que
// puro_clean. A diferencia de puro_clean, aquí sí se desbloquea el
// AudioContext en la primera interacción real (clic/tecla) del usuario:
// los navegadores bloquean audio sin eso, y sin este desbloqueo el primer
// aviso del día puede quedar mudo en silencio sin que nadie lo note.
let ctx = null;

function getCtx() {
  const AudioContextCtor = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextCtor) return null;
  if (!ctx) ctx = new AudioContextCtor();
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

if (typeof document !== 'undefined') {
  const unlock = () => {
    getCtx();
    document.removeEventListener('pointerdown', unlock);
    document.removeEventListener('keydown', unlock);
  };
  document.addEventListener('pointerdown', unlock, { once: true });
  document.addEventListener('keydown', unlock, { once: true });
}

function tone(context, freq, startOffset, duration, peak = 0.16) {
  const osc = context.createOscillator();
  const gain = context.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  const t0 = context.currentTime + startOffset;
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(peak, t0 + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(gain);
  gain.connect(context.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.05);
}

// urgent=true → tres tonos descendentes (requiere acción ahora).
// urgent=false → dos tonos ascendentes (informativo).
export function playNotificationChime(urgent = false) {
  try {
    const context = getCtx();
    if (!context) return;
    if (urgent) {
      tone(context, 880, 0, 0.12);
      tone(context, 660, 0.14, 0.12);
      tone(context, 880, 0.28, 0.18);
    } else {
      tone(context, 660, 0, 0.1);
      tone(context, 880, 0.12, 0.14);
    }
  } catch (_) {
    // Silencioso a propósito — un fallo de audio nunca debe romper la UI.
  }
}
